import type { IApiConfig } from 'mfBooking/Booking';
import { getAppConfig } from '@modules/config/appConfig';

export const bookingApiConfig = (): IApiConfig => {
  const appConfig = getAppConfig();
  return {
    API_ROOT: appConfig.API_ROOT,
    IMG_URL: appConfig.IMG_URL,
    THEME_URL: appConfig.THEME_URL,
    THEME_DEFAULT: appConfig.THEME_DEFAULT ?? '',
    KEYCLOAK_CLIENT_ID: appConfig.KEYCLOAK_CLIENT_ID,
    KEYCLOAK_REALM: appConfig.KEYCLOAK_REALM,
    KEYCLOAK_URL: appConfig.KEYCLOAK_URL,
    MAPBOX_URL: appConfig.MAPBOX_URL,
    MAPBOX_TOKEN: appConfig.MAPBOX_TOKEN,
    MAPBOX_F11_SOURCE_TILES_URL: appConfig.MAPBOX_F11_SOURCE_TILES_URL,
    MF_REMOTE_MAP_URL: appConfig.MF_REMOTE_MAP_URL,
  };
};
